import React, { useRef, useMemo, useCallback, useEffect } from "react";
import { Form, InputNumber } from "antd";
import { connect } from "dva";

const CostPlus = ({ configPerm, inherited, strategy, onChange }) => {
  const costPlusFormRef = useRef(null);
  const lastRegisteredAmountValue = useRef(null);

  const disabled = useMemo(() => {
    return !configPerm["PricingService.PricingSettings.Update"] || inherited;
  }, [configPerm, inherited]);

  const handleAmountChange = useCallback(
    newAmount => {
      if (typeof onChange === "function") {
        onChange({ amount: newAmount });
      }
    },
    [onChange],
  );

  useEffect(() => {
    if (!costPlusFormRef.current) {
      return;
    }

    if (typeof strategy?.amount === "number" && strategy.amount !== lastRegisteredAmountValue.current) {
      lastRegisteredAmountValue.current = strategy.amount;
      costPlusFormRef.current.setFieldsValue({
        amount: strategy.amount,
      });
    }
  }, [strategy?.amount]);

  return (
    <div>
      <Form layout="vertical" ref={costPlusFormRef}>
        <Form.Item label="Amount" name="amount">
          <InputNumber
            min={0}
            step={1}
            formatter={value => {
              const digitsOnly = value.match(/\d+(\.\d*)?/)?.[0] || "";

              if (!digitsOnly) {
                return digitsOnly;
              }

              const int = parseInt(digitsOnly);
              const float = parseFloat(digitsOnly);
              const fixed = float.toFixed(2);

              if (int === float) {
                return `$${digitsOnly}`;
              }

              return `$${digitsOnly.split(".")[1].length > 2 ? fixed : float}`;
            }}
            parser={value => (value ? value.replace("$", "") : "")}
            disabled={disabled}
            onChange={handleAmountChange}
          />
        </Form.Item>
      </Form>
    </div>
  );
};

export default connect(({ configs }) => ({
  configPerm: configs.configPerm,
}))(CostPlus);
